import { CaptchaToken } from './CaptchaToken';

export const FormWithCaptchaToken = ({
  className,
  children,
  triggerRecaptcha,
  ...props
}) => {
  return (
    <form
      onSubmit={triggerRecaptcha}
      role="form"
      noValidate={true}
      className={className}
      method="post"
    >
      <CaptchaToken {...props} />
      {children}
    </form>
  );
};
